import React, {RefObject} from "react";
import Label from "../../../../../components/Label/Label";
import Input from "../../../../../components/Input/Input";
import {ResultError, Return} from "../../../../../lib/result";
import {SectionProps} from "../../../../../components/Drawer/ItemDrawer";
import Section from "../../../../../components/Drawer/Section/Section";
import LabelsAnnotationsSection, {LabelsAnnotationsSectionProps} from "../../../../../components/Drawer/Sections/Metadata/LabelsAnnotationsSection";
import Description from "../../../../../components/Description/Description";
import styles from "./TeamMetadata.module.scss";
import {ManagementV1Team} from "../../../../../../gen/models/managementV1Team";
import SectionExpander from "../../../../../components/Drawer/SectionExpander/SectionExpander";

interface MetadataState {
    name: string | undefined;

    displayName: string | undefined;
    displayNameChanged: boolean;
    
    description: string | undefined;
    descriptionChanged: boolean;
}

interface MetadataProps extends SectionProps, LabelsAnnotationsSectionProps {
    team?: ManagementV1Team;
}

export default class TeamMetadata extends React.PureComponent<MetadataProps, MetadataState> {
    labelsSectionRef?: RefObject<LabelsAnnotationsSection>;
    state: MetadataState = {
        name: this.props.team?.metadata?.name,

        displayName: this.props.team?.spec?.displayName,
        displayNameChanged: false,
        
        description: this.props.team?.spec?.description,
        descriptionChanged: false,
    };

    constructor(props: MetadataProps) {
        super(props);

        this.labelsSectionRef = React.createRef<LabelsAnnotationsSection>();
    }

    create = async (team: ManagementV1Team): Promise<ResultError> => {
        // make sure metadata exists
        if (!team.metadata) {
            team.metadata = {};
        }
        if (!team.spec) {
            team.spec = {};
        }

        const metadata = team.metadata;
        if (!this.state.name) {
            metadata.generateName = "team-";
        } else {
            metadata.name = this.state.name;
        }

        team.spec.displayName = this.state.displayName;
        team.spec.description = this.state.description;

        return this.labelsSectionRef!.current!.create(metadata);
    };

    update = async (team: ManagementV1Team): Promise<ResultError> => {
        if (this.state.displayNameChanged) {
            team.spec!.displayName = this.state.displayName;
        }
        if (this.state.descriptionChanged) {
            team.spec!.description = this.state.description;
        }

        return this.labelsSectionRef!.current!.update(team.metadata!);
    };

    batch = (teams: ManagementV1Team[]): ResultError => {
        return this.labelsSectionRef!.current!.batch(teams.map(user => user.metadata!));
    };

    renderUserInfo() {
        return <div>
            <div className={styles["row"]}>
                <div>
                    <Label>Display Name</Label>
                    <Input resetable={this.props.mode === "update"} placeholder={"Team Name"} onChangedStatus={changed => this.setState({displayNameChanged: changed})} value={this.state.displayName} onChange={(e) => this.setState({displayName: e.target.value})} />
                </div>
                <div>
                    <Label>Kubernetes Name</Label>
                    <Input readOnly={this.props.mode === "update"} placeholder={"Leave empty for auto-generated name"} value={this.state.name} onChange={(e) => this.setState({name: e.target.value})} />
                </div>
            </div>
            <SectionExpander name={"Description"}>
                <Label>Description</Label>
                <Input resetable={this.props.mode === "update"}
                       onChangedStatus={changed => this.setState({descriptionChanged: changed})}
                       placeholder={`The team is doing...`}
                       value={this.state.description}
                       onChange={e => this.setState({description: e.target.value})} />
                <Description>A human readable description what the team is used for.</Description>
            </SectionExpander>
        </div>
    }

    render() {
        return <Section title={`Team Details`} noMargin>
            {
                this.props.mode !== "batch" && this.renderUserInfo()
            }
            <LabelsAnnotationsSection {...this.props} metadata={this.props.team ? this.props.team.metadata : undefined} ref={this.labelsSectionRef} />
        </Section>
    }
}